import {aiAssistantContextStore} from '@dms/ai-assistant';

import {useOnMount} from 'shared/web';

type AiAssistantLanguageSyncProps = {
  language: string;
};

/**
 * Sets the store's `language` once on mount. A language change triggers a full app refresh, so
 * `Initialize` re-runs and re-sets it — no `languageChanged` listener needed.
 */
export function AiAssistantLanguageSync(props: AiAssistantLanguageSyncProps): null {
  useOnMount(() => {
    aiAssistantContextStore.patchContext({language: props.language});
  });

  return null;
}
